module.exports = __webpack_public_path__ + "img/ga.7b659f5a.svg";